import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          TabPane,
          FormControl,
          Table,
          Modal,
          ControlLabel,
          Label,
          OverlayTrigger,
          Tooltip,
          Glyphicon,
          Image,} from "react-bootstrap";
import {ToastContainer, ToastStore} from 'react-toasts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Datetime from 'react-datetime';
import FormBuilderPage from '../formbuilder';
import { pdfjs } from 'react-pdf';

import FormdataService from "../../services/formdata-service";
import UsersService from "../../services/users-service";

import TourMap from "../../components/tour-map";
import TourReport from "../../components/tour-report";
import TourManage from "../../components/tour-manage";
import EventWidget from "../../components/widgets/event-widget";

import GLOBALS from '../../utils/Constants';
import _ from 'underscore';
import $ from 'jquery';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

//Props:
//clients
class TourConfirmation extends Component {

  constructor(props, context) {
      super(props, context);

      const storedCredentials = UsersService.sharedInstance.getStoredCredentials();
      this.state = {
          tabActiveIndex: 0,
          storedCredentials: storedCredentials,
          branches: [],
          clients: [],
          facilityLocations: [],

        }
  }

  componentWillMount(){

  }

  render() {
    return (  <div>
              <Row className="widget-top-container">
                <Col md={5} style={{backgroundColor: "white"}}>
                  <EventWidget events={this.props.events}/>
                </Col>
              </Row>
                <Row className="main-settings-content">
                    <Col>
                        <div className="settings-header">
                            <h2>Tour Confirmation
                                  {this.state.tabActiveIndex == 1
                                    ? <div className="pull-right">
                                      <FormGroup className={"col-md-12"}
                                                        style={{padding: 5, borderRadius: 5}}>
                                        <FormControl
                                            type="text"
                                            placeholder="Search Reports"
                                            value={this.state.reportSearch}
                                            onChange={(e)=>{
                                                this.setState({reportSearch: e.currentTarget.value})
                                              }}/>
                                      </FormGroup> </div>
                                    : null}
                            </h2>

                        </div>
                        <div className="tab-container" >
                          <Tabs defaultActiveKey={1} activeKey={this.state.tabActiveIndex} id="forms-tabs"
                              onSelect={(key)=>{
                                            var newState = {tabActiveIndex: key};

                                            this.setState(newState);

                                            }}>
                              <Tab eventKey={0} title="Map" className="forms-tab">
                                  {this.renderMap()}
                              </Tab>
                              <Tab eventKey={1} title="Report" className="forms-tab" >
                                  {this.renderReport()}
                              </Tab>
                              <Tab eventKey={2} title="Manage" className="forms-tab">
                                  {this.renderManage()}
                              </Tab>

                          </Tabs>
                      </div>
                      </Col>
                </Row>
                  <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
              </div>
              );
  }

  componentDidMount() {
  }

  renderMap() {
      return <TourMap facilityLocations={this.props.facilityLocations}
                      facilities={this.props.facilities}/>
  }

  renderReport() {
      return <TourReport getFormDataByType={this.props.getFormDataByType}
                        getRecnoForName={this.props.getRecnoForName}
                        facilityLocations={this.props.facilityLocations}
                        clients={this.props.clients}
                        facilities={this.props.facilities}
                        branches={this.props.branches}/>
  }

  renderManage() {
    return <TourManage facilityLocations={this.props.facilityLocations}
                        facilities={this.props.facilities}
                        getRecnoForName={this.props.getRecnoForName}/>
  }



}

export default TourConfirmation;
